import React from 'react'
import { Icon, View, Wallet } from 'reshaped'
import type { Responsive } from 'reshaped'

type WalletAvatarProps = {
  size?: Responsive<string | number> | number
}

export function WalletAvatar({ size = 8 }: WalletAvatarProps) {
  return (
    <View
      align="center"
      justify="center"
      height={size}
      width={size}
      borderRadius="circular"
      backgroundColor="neutral"
      attributes={{
        style: {
          backgroundImage: 'url(/assets/wallet-background.png)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        },
      }}
    >
      <Icon svg={Wallet} size={6} color="neutral-faded" />
    </View>
  )
}
